import { render } from "./ModalAddExistingUpsellItem.vue?vue&type=template&id=a8d163e4"
import script from "./ModalAddExistingUpsellItem.vue?vue&type=script&lang=js"
export * from "./ModalAddExistingUpsellItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__